/**
 * Kitchen Display Screen (KDS) types
 */

export type KitchenTicketStatus = 'NEW' | 'IN_PREP' | 'QC' | 'READY' | 'SERVED';

/** Ordered forward-only workflow — a ticket can only move to a later stage. */
export const KDS_STATUS_ORDER: KitchenTicketStatus[] = [
  'NEW',
  'IN_PREP',
  'QC',
  'READY',
  'SERVED',
];

/** Minutes since creation, still unserved, before a ticket counts as delayed. */
export const KDS_DELAYED_THRESHOLD_MINUTES = 15;

export interface KdsTicketItem {
  id: string;
  name: string;
  quantity: number;
  notes: string | null;
}

export interface KdsTicket {
  id: string;
  order_id: string;
  kot_id: number;
  department_id: string | null;
  status: KitchenTicketStatus;
  bill_number: number;
  mode: string;
  table_name: string | null;
  waiter_name: string | null;
  created_at: string;
  in_prep_at: string | null;
  qc_at: string | null;
  ready_at: string | null;
  served_at: string | null;
  items: KdsTicketItem[];
}

export interface KdsKpis {
  active_orders: number;
  average_time_minutes: number;
  completed_orders: number;
  delayed_orders: number;
}

export interface KdsDepartmentOption {
  id: string;
  name: string;
}
